<template>
<div class="chapter">
<div class="inner_page">
<section class="element element-container-single element-non-bodymatter element-type-copyright element-without-heading" epub:type="copyright-page" id="copyright">
<div class="text" id="copyright-text">
<p class="first first-in-chapter first-full-width copyright-content"><b>SLIMY CHICKEN ZOMNIBUS
      </b>ISBN: 978-1-61475-974-4</p>
<p class="subsq copyright-content">Copyright © 2019 WordFire, Inc.</p>
<p class="subsq copyright-content"><i>Slimy Underbelly</i> copyright © 2014 WordFire, Inc. 
      Originally published by Kensington Books.</p>
<p class="subsq copyright-content"><i>Tastes Like Chicken</i> copyright © 2017 WordFire, Inc. 
      Originally published by WordFire Press.</p>
<p class="subsq copyright-content">All rights reserved. No part of this book may be reproduced or transmitted in any form or by any electronic or mechanical means, including photocopying, recording or by any information storage and retrieval system, without the express written permission of the copyright holder, except where permitted by law. This novel is a work of fiction. Names, characters, places and incidents are either the product of the author’s imagination, or, if real, used fictitiously.</p>
<p class="subsq copyright-content">This book is licensed for your personal enjoyment only. This ebook may not be re-sold or given away to other people. If you would like to share this book with another person, please purchase an additional copy for each recipient. Thank you for respecting the hard work of this author.</p>
<p class="subsq copyright-content">Cover paintings by Jeff Herndon</p>
<p class="subsq copyright-content">Cover design by Janet McDonald</p>
<p class="subsq copyright-content">Kevin J. Anderson, Art Director</p>
<p class="subsq copyright-content">Published by
      WordFire Press, LLC
      PO Box 1840
      Monument, CO 80132</p>
<p class="subsq copyright-content">Kevin J. Anderson &amp; Rebecca Moesta, Publishers</p>
<p class="subsq copyright-content">Join our WordFire Press Readers Group for free books, 
      sneak previews, updates on new projects, and other giveaways 
      Sign up at  <a class="content-external-link text-is-url" href="https://eepurl.com/c_lmZP" target="_blank"><span class="underline">https://eepurl.com/c_lmZP</span></a></p>
<p class="created-with-vellum"><a href="http://tryvellum.com/created" target="_blank"><span class="created-with-vellum-image-decorator"><span class="created-with-vellum-image-size-container"><img alt="Created with Vellum" class="created-with-vellum-image" src="images/vellum-created.svg"/></span></span> <span class="created-with-vellum-text">Created with Vellum</span></a></p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?6b333fca